"use client";
import { useAppContext } from "../appContext";
import HeaderDesktop from "./headerDesktop";
import HeaderMobile from "./headerMobile";
import { m } from "framer-motion";

interface HeaderProps {
  data?: any;
}

const headerVariants = {
  initial: {
    y: "-100%",
  },
  animate: {
    y: 0,
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

export default function Header({ data }: HeaderProps) {
  const { translations } = useAppContext();

  return (
    <m.header
      variants={headerVariants}
      initial="initial"
      animate="animate"
      key="header"
      className="fixed top-0 left-0 w-full max-h-dvh flex flex-col z-[1000002]"
    >
      <HeaderDesktop data={data} translations={translations} />
      <HeaderMobile data={data} translations={translations} />
    </m.header>
  );
}
